import {CSSProperties} from "react";

const iconStyle: CSSProperties = {
  width: '18px',
  height: '18px',
  marginRight: '5px'
}

export const styles = {
  Icon: iconStyle,
}